
// @ts-nocheck
import locale_fr_46js_1a96390b from "#nuxt-i18n/1a96390b";
import locale_en_46js_fdf09912 from "#nuxt-i18n/fdf09912";
import locale_es_46js_6b091ed4 from "#nuxt-i18n/6b091ed4";

export const localeCodes =  [
  "fr",
  "en",
  "es"
]

export const localeLoaders = {
  fr: [
    {
      key: "locale_fr_46js_1a96390b",
      load: () => Promise.resolve(locale_fr_46js_1a96390b),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46js_fdf09912",
      load: () => Promise.resolve(locale_en_46js_fdf09912),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46js_6b091ed4",
      load: () => Promise.resolve(locale_es_46js_6b091ed4),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/d573372c" /* webpackChunkName: "config_i18n_46config_46ts_d573372c" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "fr",
      language: "fr-FR",
      name: "Français",
      sugar: "francais",
      _hreflang: "fr-FR",
      _sitemap: "fr-FR",
      files: [
        {
          path: "/srv/www/uia-frontend/i18n/locales/fr.js",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      language: "en-US",
      name: "English",
      sugar: "anglais",
      _hreflang: "en-US",
      _sitemap: "en-US",
      files: [
        {
          path: "/srv/www/uia-frontend/i18n/locales/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      language: "es-ES",
      name: "Español",
      sugar: "espagnol",
      _hreflang: "es-ES",
      _sitemap: "es-ES",
      files: [
        {
          path: "/srv/www/uia-frontend/i18n/locales/es.js",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "fr",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "config",
  pages: {
    actions: {
      fr: "/uia-irol/actions",
      en: "/uia-irol/actions",
      es: "/uia-irol/acciones"
    },
    "actions-slug": {
      fr: "/uia-irol/actions/[slug]",
      en: "/uia-irol/actions/[slug]",
      es: "/uia-irol/acciones/[slug]"
    },
    articles: {
      fr: "/actualites",
      en: "/news",
      es: "/noticias"
    },
    "articles-category-slug": {
      fr: "/actualites/categories/[slug]",
      en: "/news/categories/[slug]",
      es: "/noticias/categorias/[slug]"
    },
    "articles-slug": {
      fr: "/actualites/[slug]",
      en: "/news/[slug]",
      es: "/noticias/[slug]"
    },
    "auth-access-denied": {
      fr: "/compte/acces-refuse",
      en: "/account/access-denied",
      es: "/cuenta/acceso-denegado"
    },
    "auth-choose": {
      fr: "/compte/choisir",
      en: "/account/choose",
      es: "/cuenta/elegir"
    },
    "auth-confirm": {
      fr: "/compte/confirmer",
      en: "/account/confirm",
      es: "/cuenta/confirmar"
    },
    "auth-email": {
      fr: "/compte/email",
      en: "/account/email",
      es: "/auth/email"
    },
    "auth-private": {
      fr: "/mon-espace",
      en: "/my-account",
      es: "/mi-cuenta"
    },
    "auth-private-commissions": {
      fr: "/mon-espace/commissions",
      en: "/my-account/commissions",
      es: "/mi-cuenta/comisiones"
    },
    "auth-private-committees": {
      fr: "/mon-espace/comites",
      en: "/my-account/committees",
      es: "/mi-cuenta/comites"
    },
    "auth-private-events": {
      fr: "/mon-espace/evenements",
      en: "/my-account/events",
      es: "/mi-cuenta/eventos"
    },
    "auth-private-my-documents": {
      fr: "/mon-espace/mes-documents",
      en: "/my-account/my-documents",
      es: "/mi-cuenta/mis-documentos"
    },
    "auth-private-national-committees": {
      fr: "/mon-espace/comites-nationaux",
      en: "/my-account/national-committees",
      es: "/mi-cuenta/comites-nacionales"
    },
    "auth-private-payment": {
      fr: "/mon-espace/paiement",
      en: "/my-account/payment",
      es: "/mi-cuenta/pago"
    },
    "auth-private-payment-result": {
      fr: "/mon-espace/resultat-paiement",
      en: "/my-account/payment-result",
      es: "/mi-cuenta/resultado-pago"
    },
    "auth-private-profile": {
      fr: "/mon-espace/profil",
      en: "/my-account/profile",
      es: "/mi-cuenta/perfil"
    },
    "auth-private-bar-profile": {
      fr: "/mon-espace/profil-barreau",
      en: "/my-account/bar-profile",
      es: "/mi-cuenta/perfil-colegio"
    },
    "auth-private-bar-members": {
      fr: "/mon-espace/representants-barreau",
      en: "/my-account/bar-members",
      es: "/mi-cuenta/miembros-colegio"
    },
    "auth-private-firm-profile": {
      fr: "/mon-espace/profil-cabinet",
      en: "/my-account/firm-profile",
      es: "/mi-cuenta/perfil-firma"
    },
    "auth-private-firm-members": {
      fr: "/mon-espace/membres-cabinet",
      en: "/my-account/firm-members",
      es: "/mi-cuenta/miembros-firma"
    },
    "auth-private-president-communication": {
      fr: "/mon-espace/message-aux-membres",
      en: "/my-account/message-to-members",
      es: "/mi-cuenta/mensaje-a-miembros"
    },
    "auth-private-mandates": {
      fr: "/mon-espace/mandats",
      en: "/my-account/mandates",
      es: "/mi-cuenta/mandatos"
    },
    "auth-private-transactions": {
      fr: "/mon-espace/transactions",
      en: "/my-account/transactions",
      es: "/mi-cuenta/transacciones"
    },
    "auth-change-email-confirm": {
      fr: "/compte/modifier-email",
      en: "/account/change-email",
      es: "/cuenta/cambiar-email"
    },
    "auth-redirect": {
      fr: "/compte/redirection",
      en: "/account/redirect",
      es: "/cuenta/redireccion"
    },
    "auth-reset-password": {
      fr: "/compte/reinitialiser-mot-de-passe",
      en: "/account/reset-password",
      es: "/cuenta/restablecer-contrasena"
    },
    "auth-signup": {
      fr: "/compte/inscription",
      en: "/account/signup",
      es: "/cuenta/registro"
    },
    "auth-subscribe": {
      fr: "/compte/adhesion",
      en: "/account/membership",
      es: "/cuenta/membresia"
    },
    "charters-and-resolutions": {
      fr: "/a-propos/chartes-et-resolutions-uia",
      en: "/about/charters-and-resolutions",
      es: "/sobre-la-uia/resoluciones-y-cartas-uia"
    },
    commissions: {
      fr: "/reseau/commissions",
      en: "/network/commissions",
      es: "/red/comisiones"
    },
    "commissions-slug": {
      fr: "/reseau/commissions/[slug]",
      en: "/network/commissions/[slug]",
      es: "/red/comisiones/[slug]"
    },
    committees: {
      fr: "/reseau/comites",
      en: "/network/committees",
      es: "/red/comites"
    },
    "committees-slug": {
      fr: "/reseau/comites/[slug]",
      en: "/network/committees/[slug]",
      es: "/red/comites/[slug]"
    },
    contact: {
      fr: "/contact",
      en: "/contact",
      es: "/contacto"
    },
    "documents-library": {
      fr: "/ressources-digitales/bibliotheque",
      en: "/digital-resources/library",
      es: "/recursos-digitales/biblioteca"
    },
    "documents-library-documentId": {
      fr: "/ressources-digitales/bibliotheque-documents/[documentId]",
      en: "/digital-resources/documents-library/[documentId]",
      es: "/recursos-digitales/biblioteca-documentos/[documentId]"
    },
    events: {
      fr: "/evenements",
      en: "/events",
      es: "/eventos"
    },
    "events-slug": {
      fr: "/evenements/[slug]",
      en: "/events/[slug]",
      es: "/eventos/[slug]"
    },
    "events-slug-register": {
      fr: "/evenements/[slug]/inscription",
      en: "/events/[slug]/register",
      es: "/eventos/[slug]/registro"
    },
    "events-slug-register-confirm": {
      fr: "/evenements/[slug]/confirmation-inscription",
      en: "/events/[slug]/register-confirm",
      es: "/eventos/[slug]/confirmar-registro"
    },
    "juriste-internationals": {
      fr: "/ressources-digitales/juriste-internationals",
      en: "/digital-resources/juriste-internationals",
      es: "/recursos-digitales/juriste-internationals"
    },
    members: {
      fr: "/annuaire/membres",
      en: "/directory/members",
      es: "/directorio/membresia"
    },
    "members-bars": {
      fr: "/annuaire/barreaux",
      en: "/directory/bars",
      es: "/directorio/colegios"
    },
    "members-bars-slug": {
      fr: "/annuaire/barreaux/[slug]",
      en: "/directory/bars/[slug]",
      es: "/directorio/colegios/[slug]"
    },
    "members-firms": {
      fr: "/annuaire/cabinets",
      en: "/directory/firms",
      es: "/directorio/firmas"
    },
    "members-slug": {
      fr: "/annuaire/membres/[slug]",
      en: "/directory/members/[slug]",
      es: "/directorio/membresia/[slug]"
    },
    "national-committees": {
      fr: "/reseau/luia-dans-le-monde",
      en: "/network/the-uia-worldwide",
      es: "/red/la-uia-en-el-mundo"
    },
    "national-committees-slug": {
      fr: "/reseau/luia-dans-le-monde/[slug]",
      en: "/network/the-uia-worldwide/[slug]",
      es: "/red/la-uia-en-el-mundo/[slug]"
    },
    pages: {
      fr: "/pages",
      en: "/pages",
      es: "/paginas"
    },
    "pages-bars-and-organisations": {
      fr: "/reseau/barreaux-et-organisations",
      en: "/network/bars-and-organisations",
      es: "/red/bares-y-organizaciones"
    },
    "pages-collection-types-rassembler-les-barreaux-du-monde": {
      fr: "/pages-collection-types/rassembler-les-barreaux-du-monde",
      en: "/pages-collection-types/bringing-together-the-worlds-bar-associations",
      es: "/pages-collection-types/reunir-los-colegios-de-abogados-del-mundo"
    },
    "pages-endowment-fund": {
      fr: "/a-propos/fonds-de-dotation-uia",
      en: "/about/uia-endowment-fund",
      es: "/sobre-la-uia/fondo-de-dotacion-de-la-uia"
    },
    "pages-governance": {
      fr: "/a-propos/gouvernance",
      en: "/about/governance",
      es: "/sobre-la-uia/gobernanza"
    },
    "pages-become-uia-member": {
      fr: "/adhesion-membres/devenir-membre-de-luia",
      en: "/membership/become-uia-member",
      es: "/membresia/membresia-uia"
    },
    "pages-join-the-uia": {
      fr: "/adhesion-membres/rejoindre-luia",
      en: "/membership/join-the-uia",
      es: "/membresia/unirse-a-la-uia"
    },
    "pages-podcasts": {
      fr: "/ressources-digitales/podcasts-uia",
      en: "/digital-resources/uia-podcasts",
      es: "/recursos-digitales/podcasts-uia"
    },
    "membership-refer-a-friend": {
      fr: "/adhesion-membres/parrainez-un-confrere",
      en: "/membership/refer-a-friend",
      es: "/membresia/recomiende-un-companero-o-companera"
    },
    "pages-sponsorship": {
      fr: "/partenariat",
      en: "/sponsorship",
      es: "/patrocinios"
    },
    "pages-slug": {
      fr: "/pages/[slug]",
      en: "/pages/[slug]",
      es: "/paginas/[slug]"
    },
    "pages-uiacademy": {
      fr: "/uiacademy",
      en: "/uiacademy",
      es: "/uiacademy"
    },
    "pages-uia-world-forum-of-mediation-centres": {
      fr: "/reseau/forum-mondial-de-mediation-UIA",
      en: "/network/uia-world-forum-of-mediation-centres",
      es: "/red/foro-mundial-de-los-centros-de-mediacion-de-la-uia"
    },
    "pages-uiadvance": {
      fr: "/uiadvance",
      en: "/uiadvance",
      es: "/uiadvance"
    },
    "pages-who-we-are": {
      fr: "/a-propos/qui-sommes-nous",
      en: "/about/who-we-are",
      es: "/sobre-la-uia/quienes-somos"
    },
    "pages-learn-more": {
      fr: "/en-savoir-plus",
      en: "/learn-more",
      es: "/saber-mas"
    },
    "partner-events": {
      fr: "/evenements-partenaires",
      en: "/partner-events",
      es: "/eventos-asociados"
    },
    partners: {
      fr: "/partenaires",
      en: "/partners",
      es: "/asociados"
    },
    press: {
      fr: "/a-propos/presse",
      en: "/about/press",
      es: "/sobre-la-uia/prensa"
    },
    publications: {
      fr: "/ressources-digitales/publications",
      en: "/digital-resources/publications",
      es: "/recursos-digitales/publicaciones"
    },
    search: {
      fr: "/recherche",
      en: "/search",
      es: "/busqueda"
    },
    uiadvance: {
      fr: "/reseau/reseau-uiadvance",
      en: "/network/uiadvance-network",
      es: "/red/red-uiadvance"
    }
  },
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "fr",
    language: "fr-FR",
    name: "Français",
    sugar: "francais",
    _hreflang: "fr-FR",
    _sitemap: "fr-FR",
    files: [
      {
        path: "/srv/www/uia-frontend/i18n/locales/fr.js",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    language: "en-US",
    name: "English",
    sugar: "anglais",
    _hreflang: "en-US",
    _sitemap: "en-US",
    files: [
      {
        path: "/srv/www/uia-frontend/i18n/locales/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    language: "es-ES",
    name: "Español",
    sugar: "espagnol",
    _hreflang: "es-ES",
    _sitemap: "es-ES",
    files: [
      {
        path: "/srv/www/uia-frontend/i18n/locales/es.js",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/